const { getElements } = window.BAO.Utils
class PauseVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.checkIfShouldPause()
    this.toggleIcons()
  }

  setupListeners () {
    super.setupListeners()

    this.toggleVideos = this.toggleVideos.bind(this)

    if (this?.els?.trigger?.exists) {
      this.listeners.add(this.els.trigger.element, 'click', this.toggleVideos)
    }
  }

  toggleVideos () {
    // Videos are paused. Play them.
    if (this.isPaused) {
      window.sessionStorage.removeItem('pauseVideo')

      this.els.text.element.innerHTML = this.els.trigger.element.dataset.pauseText

      this.playAllVideos()
    } else {
      // Videos are playing. Pause them.
      window.sessionStorage.setItem('pauseVideo', 'true')

      this.els.text.element.innerHTML = this.els.trigger.element.dataset.playText

      this.pauseAllVideos()
    }
  }

  toggleIcons () {
    this.els.pause?.exists &&
      this.els.pause.element.setAttribute('aria-hidden', this.isPaused)
    this.els.play?.exists &&
      this.els.play.element.setAttribute('aria-hidden', !this.isPaused)
  }

  checkIfShouldPause () {
    if (this.isPaused) {
      if (this?.els?.text?.exists && this?.els?.trigger.exists) {
        this.els.text.element.innerHTML = this.els.trigger.element.dataset.playText
      }

      this.pauseAllVideos()
    }
  }

  playAllVideos () {
    const videoEls = getElements('lazy-video video')

    videoEls.forEach(el => {
      el.play()
      el.setAttribute('autoplay', '')
    })

    this.toggleIcons()
  }

  pauseAllVideos () {
    const videoEls = getElements('lazy-video video')

    videoEls.forEach(el => {
      el.pause()
      if (el.hasAttribute('autoplay')) {
        el.removeAttribute('autoplay')
        el.setAttribute('should-autoplay', '')
      }
    })

    this.toggleIcons()
  }

  get isPaused () {
    return window.sessionStorage.getItem('pauseVideo')
  }
}

if (!customElements.get('pause-video')) {
  customElements.define('pause-video', PauseVideo)
}
